import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { CloseActivePopup } from '../../../actions/popupActions';

// Popup imports
class LevelRemoveWarning extends React.Component {
    handleRemoveClick = () => {
        const { dispatch, properties } = this.props;
        properties.onRemove();
        dispatch(CloseActivePopup());
    }

    handleCancelClick = () => {
        const { dispatch } = this.props;
        dispatch(CloseActivePopup());
    }

    render = () => {

        return (
            <>
                <h1>
                    Waarschuwing
                </h1>
                <p>
                    Weet je zeker dat je dit level wilt verwijderen?
                </p>
                <div className="button-container">
                    <button type="button"
                        className="btn-remove"
                        onClick={this.handleRemoveClick}
                    >
                        Verwijder
                    </button>
                    <button type="button"
                        className="btn-cancel"
                        onClick={this.handleCancelClick}
                    >
                        Toch niet
                    </button>
                </div>
            </>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LevelRemoveWarning);